import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { downgradeComponent } from '@angular/upgrade/static';

import { SharedModule } from '../../shared';

/* Account Configuration entry components */
import { ContactFormComponent } from './contact-form/contact-form.component';
import { AccountDataFormComponent } from './account-data-form/account-data-form.component';
import { IngestFormatsComponent } from './ingest-formats/ingest-formats.component';
import { KeyboardExpansionComponent } from './keyboard-expansions/keyboard-expansion.component';
import { IngestFormatsApiService } from '../../shared/services/ingest-formats.api.service';
import { KeyboardApiService } from '../../shared/services/keyboard-api.service';
import { KeyShortcutsComponent, KeyshortcutDialogComponent } from './key-shortcuts/key-shortcuts.component';
import { KeyShortcutsApiService } from '../../shared/services/key-shortcuts.api.service';


/*
   This page has angular.js components in between serverside rendered html.
   We are not wrapping each one in an Angular UpgradeComponent because it would
   be cumbersome and give us no benefit. They are small and independent enough
   to instead be rewritten directly into Angular components, and then added
   to the below module.

   Contrary to the hybrid pages with single entrypoints, this module does
   not get lazily-loaded. We instead import it into the RootAppModule.

   c.f. site-configuration.app.module, cloud-configuration.app.module, user-configuration.app.module
*/

const accountConfigurationComponents = [
   ContactFormComponent,
   AccountDataFormComponent,
   IngestFormatsComponent,
   KeyboardExpansionComponent,
   KeyshortcutDialogComponent,
   KeyShortcutsComponent,
];

@NgModule({
   declarations: accountConfigurationComponents,
   imports: [
      CommonModule,
      ReactiveFormsModule,
      SharedModule,
   ],
   providers: [ IngestFormatsApiService, KeyboardApiService, KeyShortcutsApiService ],
   exports: accountConfigurationComponents,
})
export class AccountConfigurationAppModule {}

export const AccountConfigurationAjsModule = angular.module('hybd.account.configuration', []);

AccountConfigurationAjsModule
   .directive('bbContactForm', downgradeComponent({component: ContactFormComponent}))
   .directive('bbAccountDataForm', downgradeComponent({component: AccountDataFormComponent}))
   .directive('bbIngestFormats', downgradeComponent({component: IngestFormatsComponent}))
   .directive('bbKeyShortcuts', downgradeComponent({component: KeyShortcutsComponent}))
   .directive('bbKeyboardExpansion', downgradeComponent({component: KeyboardExpansionComponent}));
